export const MENTEE = 'mentee'
export const SET_MENTEES_LIST = MENTEE + '/SET_MENTEES_LIST'
export const SET_MENTEE = MENTEE + '/SET_MENTEE'